module.exports = __webpack_public_path__ + "static/media/ESGI.40325c2a.png";